/**
 * hellopanda-hovereffect
 */
const HELLOPANDA_HOVEREFFECT = {
  init: function() {

    const _ = this;

    document.addEventListener('DOMContentLoaded', function() {
      _.set_effect_cover();
    });

  },
  set_effect_cover: function() {

    const _ = this;

    const hovereffects = document.querySelectorAll('.wp-block-hellopanda-hover-effect-cover-block');
    hovereffects.forEach(element => {
      
      let cover = null;
      const rule = element.getAttribute('cover');
      if (rule) {
        cover = element.closest(rule);
        if (cover) {
          cover.classList.add('wp-block-hellopanda-hover-effect-trigger-block');
        }
      }

    });

  }
};
HELLOPANDA_HOVEREFFECT.init();